import classNames from "classnames";
import { ReactNode } from "react";

type NumberInputProps = {
  value?: number;
  onChange: (value?: number) => void;
  placeholder?: string;
  min?: number;
  max?: number;
  className?: string;
  size?: "sm" | "md";
  leftAddon?: ReactNode;
};

/**
 * @component NumberInput
 * @description A number input used on the filter drawer form.
 */
function NumberInput({
  value,
  onChange,
  placeholder = "Enter a number",
  min = 1,
  max,
  className,
  size = "md",
  leftAddon,
}: NumberInputProps) {
  // Prevents invalid characters from being entered into the input field.
  // This ensures only positive integers can be input.
  const handlePositiveIntegerOnly = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (["e", ".", "-", " "].includes(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <div
      className={classNames(
        "box-border flex px-3 border border-border-base rounded-xl placeholder-fg-muted sm-normal",
        "focus-within:outline-solid focus-within:-outline-offset-1 focus-within:outline-blue-600 focus-within:outline-2",
        className,
        {
          "h-[50px]": size === "md",
          "h-10": size === "sm",
        }
      )}
    >
      {leftAddon && <div className="flex items-center">{leftAddon}</div>}
      <input
        placeholder={placeholder}
        className={classNames("w-full outline-hidden appearance-none", {
          "sm-normal": size === "sm",
          "md-normal": size === "md",
        })}
        type="number"
        min={min}
        max={max}
        value={value ?? ""}
        onChange={(e) =>
          onChange(e.target.value ? parseInt(e.target.value) : undefined)
        }
        onKeyDown={handlePositiveIntegerOnly}
      />
    </div>
  );
}

export default NumberInput;
